export enum CatalogListTabType {
  ALL = 'all',
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  UNAVAILABLE = 'unavailable',
}
